
export class FeeSchedule {
  id: number;
  version: number;
  contractId: number;
  projectId: number;
  billingPlanId: number;
  clinId: number;
  projectModId: number;
  contractModId: number;
  feeScheduleType: FeeType;
  feeSubType: FeeSubType;
  feeMethod: FeeMethod;
  invoiceDescription: string;
  feeRetainagePercent: number;
  itdRetainageAmount: number;
  retainageInvoiceDate: string;

  baseAwardFeePercent: number;
  feePool: number;
  feeAward: number;	//Fixme: See if this can be renamed, removed
  determinationAmount: number;
  targetRevenueRecPercentage: number;
  awardedOn: string;
  feePercentage: string;

  incentiveAmount?: number;

  popFrom: string;
  popThru: string;
  invoiced: boolean = false;
}

export enum FeeType {
  Fixed = 'FIXED',
  Incentive = 'INCENTIVE',
  Award = 'AWARD',
  Retainage = 'RETAINAGE'
}

export enum FeeSubType {
  Base = 'BASE',
  Determination = 'DETERMINATION',
  Incentive = 'INCENTIVE'
}

export enum FeeMethod {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}